import {Location} from '@angular/common';
import {Injectable, OnDestroy} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';

declare const ga: any;

/**
 * Handles analyticsservice for this module.
 */
@Injectable()
export class AnalyticsService implements OnDestroy {

  protected destroy$ = new Subject<boolean>();

  private enabled: boolean;

  constructor(private location: Location, private router: Router) {
    this.enabled = false;
  }

  /**
   * Handles trackpageviews for this module.
   */
  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  trackPageViews() {
    if (this.enabled) {
      this.router.events
        .pipe(
          takeUntil(this.destroy$),
          filter((event) => event instanceof NavigationEnd),
        )
        .subscribe({
          next: () => {
            ga('send', {hitType: 'pageview', page: this.location.path()});
          }
        });
    }
  }

  /**
   * Handles trackevent for this module.
   */
  trackEvent(eventName: string) {
    if (this.enabled) {
      ga('send', 'event', eventName);
    }
  }
}


